import Vue from 'vue';
import Store from './Store/Store';
export const EventBus = new Vue({
    store:Store,
    mounted: function(){

    },
    methods:{
        updateQueryObj(_keyValArr){
            this.$store.commit('setQueryObj',_keyValArr);
        }
    }
});